module.exports = __webpack_public_path__ + "static/media/eurodrive-col-2.ae2cbc84.png";